import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("module/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(module_id) {
  const url = get_api_path("module/detail", {}, { module_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(module_id) {
  const url = get_api_path("module/delete", {}, { module_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(module_id, data) {
  const url = get_api_path("module/update", {}, { module_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(mastery_id, data) {
  const url = get_api_path("module/create", {}, { mastery_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function schedule(module_id, { query }) {
  const url = get_api_path("module/schedule", query, { module_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export const REQUIREMENTS = ["compulsory", "elective"];
export const TYPES = ["form", "movement", "routine"];
export const FAMILIES = ["barehand", "weapon"];
export const SPECIALISATIONS = ["longfist", "southern", "taiji", "traditional", "broadsword", "sword", "cudgel", "spear"];
